import React, { useState } from "react";
const GUEST_NAME = "guest_name";

const GuestForm = ({ onSubmit }) => {
  const [name, setName] = useState(
    localStorage.getItem(GUEST_NAME) ? localStorage.getItem(GUEST_NAME) : ""
  );
  const [error, setError] = useState(null);

  const onEnter = () => {
    if (name[0]) {
      localStorage.setItem(GUEST_NAME, name);
      onSubmit(name);
    } else setError("Please enter a name.");
  };
  return (
    <div>
      <input
        className="input-box"
        placeholder="Your Name"
        value={name}
        type="text"
        onChange={(e) => setName(e.target.value)}
        onKeyUp={(e) => {
          if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            onEnter();
          }
        }}
      />
      <br />
      <br />
      <button
        onClick={onEnter}
        type="submit"
        className="confirm-button mt-1"
        disabled={!name}
      >
        Join Without an Account
      </button>
      {error && <div className="server-response-error">{error}</div>}
    </div>
  );
};

export default GuestForm;
